const rentals = [
    {
        id: 1,
        status: "Innlevert",
        deliveryDate: "01.01.2020 kl 12:00",
        submissionDate: "01.01.2020 kl 12:00",
        pay: "Workstedet AS",
        leading: "Ole Hansen",
        carRegNo: "AB12345",
        carType: "For Fiesta",
        customerReg: "BB32165",
        resNo: "13132131",
        reference: "Var ref",
        paymentStatus: "AUT",
        change: "LUKKET",
    },
    {
        id: 2,
        status: "Innlevert",
        deliveryDate: "01.01.2020 kl 12:00",
        submissionDate: "01.01.2020 kl 12:00",
        pay: "Workstedet AS",
        leading: "Ole Hansen",
        carRegNo: "AB12345",
        carType: "For Fiesta",
        customerReg: "BB32165",
        resNo: "13132131",
        reference: "Var ref",
        paymentStatus: "AUT",
        change: "LUKKET",
    },
    {
        id: 3,
        status: "Utlevert",
        deliveryDate: "05.01.2020 kl 13:00",
        submissionDate: "05.01.2020 kl 13:00",
        pay: "Workstedet AS",
        leading: "Ole Hansen",
        carRegNo: "AB12345",
        carType: "For Fiesta",
        customerReg: "BB32165",
        resNo: "13132131",
        reference: "Var ref",
        paymentStatus: "AUT",
        change: "LUKKET",
    },
    {
        id: 4,
        status: "Utlevert",
        deliveryDate: "05.01.2020 kl 13:00",
        submissionDate: "05.01.2020 kl 13:00",
        pay: "Ole Hansen",
        leading: "Ole Hansen",
        carRegNo: "AB12345",
        carType: "For Fiesta",
        customerReg: "BB32165",
        resNo: "13132131",
        reference: "Var ref",
        paymentStatus: "SMS",
        change: "LUKKET",
    },
    {
        id: 5,
        status: "Bestilt",
        deliveryDate: "08.01.2020 kl 14:00",
        submissionDate: "08.01.2020 kl 14:00",
        pay: "Ole Hansen",
        leading: "Ole Hansen",
        carRegNo: "AB12345",
        carType: "For Fiesta",
        customerReg: "BB32165",
        resNo: "13132131",
        reference: "Var ref",
        paymentStatus: "SMS",
        change: "APNE",
    },
    {
        id: 6,
        status: "Bestilt",
        deliveryDate: "08.01.2020 kl 14:00",
        submissionDate: "08.01.2020 kl 14:00",
        pay: "Workstedet AS",
        leading: "Ole Hansen",
        carRegNo: "AB12345",
        carType: "For Fiesta",
        customerReg: "BB32165",
        resNo: "13132131",
        reference: "Var ref",
        paymentStatus: "SMS",
        change: "APNE",
    },
];

const getRentals = async () => {
    return rentals;
};

export const RentalsService = {
    getRentals,
};
